import { useI18n } from '../../i18n/useI18n.js'

import { Button } from '../Button/Button.jsx'
import { Heart } from '../icons/Heart'

import styles    from './HeartButton.module.scss'

/**
 * Toggle button for marking a product as favourite.
 *
 * IMPORTANT: `onClick` and `onTouchEnd` both call `e.stopPropagation()` so that
 * the button can be safely embedded inside a RecordTable row without triggering
 * the row's own click handler.
 *
 * @param {object}  props
 * @param {boolean} props.isActive   - Whether the product is currently a favourite.
 * @param {Function} props.onToggle  - Called when the user clicks / taps the button.
 * @param {string} [props.size] - Icon size passed to the Button component (e.g. "small", "medium", "large").
 * @param {string}  [props.className]    - Extra class merged onto the root element.
 */
export function HeartButton({ isActive, onToggle, size="small", className }) {
  const { t } = useI18n()

  /** @param {React.SyntheticEvent} e */
  function handleClick(e) {
    e.stopPropagation()
    onToggle?.()
  }

  /** @param {React.TouchEvent} e */
  function handleTouchEnd(e) {
    e.stopPropagation()
  }

  const rootClass = [
    styles.heartButton,
    isActive ? styles.active : styles.inactive,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <Button
      type="button"
      variant='ghost'
      size={size}
      className={rootClass}
      onClick={handleClick}
      onTouchEnd={handleTouchEnd}
      aria-label={isActive ? t('favorites.remove') : t('favorites.add')}
      aria-pressed={isActive}
    >
      <Heart filled={isActive} />
    </Button>
    // <button
    //   type="button"
    //   className={rootClass}
    //   onClick={handleClick}
    //   onTouchEnd={handleTouchEnd}
    //   aria-label={isActive ? t('favorites.remove') : t('favorites.add')}
    //   aria-pressed={isActive}
    // >
    //   <Heart width={size} height={size} filled={isActive} />
    // </button>
  )
}
